import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_POINTS_EARN_CALCULATION } from 'actions/apiActionConstants'
import requestLoyaltyEarnPointsCalculation from 'api/loyalty/requestLoyaltyEarnPointsCalculation'
import buildPointsKey from 'loyalty/lib/pointsCalculation/buildPointsKey'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { getHasLuxPlusOrSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscription'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'

function submitLoyaltyPointsEarnCalculationRequest(
  calculationRequest: App.LoyaltyPointsEarnCalculationRequest,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const customerId = state.auth.account.memberId ?? ''
    const currency = state.geo.currentCurrency
    const pointsEarnCalculationKey = buildPointsKey(calculationRequest, customerId)
    const existingCalculation = state.loyalty.pointsEarnCalculations[pointsEarnCalculationKey]
    const hasLuxPlusOrSubscriptionInCart = getHasLuxPlusOrSubscriptionInCart(state)
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const isCurrentRegionUserLoyaltyRegion = getIsCurrentRegionUserLoyaltyRegion(state)

    if (
      !getIsLoyaltyEnabled(state) ||
      (hasLoyaltyAccount && !isCurrentRegionUserLoyaltyRegion) ||
      existingCalculation?.data ||
      existingCalculation?.fetching ||
      existingCalculation?.error
    ) return

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_POINTS_EARN_CALCULATION,
      pointsEarnCalculationKey,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => requestLoyaltyEarnPointsCalculation(calculationRequest, {
        customerId,
        currency,
        luxPlusMember: hasLuxPlusOrSubscriptionInCart,
      }),
    })
  }
}

export default submitLoyaltyPointsEarnCalculationRequest
